import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import {
  ValoreEconomicoCostiGestioneFormComponent
} from '../../../form/sez-economica/valore-economico-costi-gestione-form.component';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Petitum } from '../../../models/petitum';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
    templateUrl: '../../../form/sez-economica/valore-economico-costi-gestione-form.component.html',
  selector: 'div [sezione-economica-costi-gestione-edit]',
})

export class SezioneEconomicaCostiGestioneEditComponent extends ValoreEconomicoCostiGestioneFormComponent implements OnInit {
  petitumRevisione: PetitumRevisione;
  urlUpdate: string;
  sezione: SezioneEconomica;
  fascicolo: FascicoloFull;
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  constructor(
    protected operationService: OperationsService,
    protected campiForm: FormBuilder,
    protected helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Modifica revisione valori economici');
    this.isInserimento(false);
  }

  getPetitumRevisione() {
    return this.petitumRevisione;
  }

  getRequest(petitumRevisione: PetitumRevisione) {
    let idSezione: string = PropertiesSettings.NEW_SEZIONE;
    if (this.sezione) {
      idSezione = this.sezione.id;
    }
    this.operationService.addPetitumRevisione(this.urlUpdate, petitumRevisione, idSezione, this.fascicolo.id).
      subscribe((response: any) => this.datiResponse(response));
  }

  datiResponse(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, petitum: Petitum, fascicolo: FascicoloFull, urlUpdate: string) {
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.petitumRevisione = petitum.petitumRevisioni[petitum.petitumRevisioni.length - 1];
    this.urlUpdate = urlUpdate;
    this.createForm();
    this.populateSelect();
  }

}
